<div class="container">
    <div class="mobile">
        <div class="line_1">
            <img class="colissimoLogo" src="assets/images/Colissimo_Logo.svg">
            <div class="label"> {{ "header.num" | translate}}</div>
            <div class="label" *ngIf="trackingResponse.parcel.parcelNumber != null">
                {{trackingResponse.parcel.parcelNumber}}
            </div>
        </div>
        <div class="line_2" *ngIf="trackingResponse.parcel.customerCompanyName ">
            <div class="labelExpedition"> {{ "header.expedition" | translate}} </div>
            <div class="headerCompanyNameMobile">
                {{trackingResponse.parcel.customerCompanyName}}
            </div>
        </div>
    </div>
    <div class="desktop">
        <div class="line">
            <img class="colissimo_logo" src="assets/images/Colissimo_Logo.svg" dataqsi="logoPrincipal">
            <div class="label"> {{ "header.num" | translate}}</div>
            <div class="label" *ngIf="trackingResponse.parcel.parcelNumber != null && trackingResponse.parcel.parcelNumber !==''" dataqsi="numeroColis">
                {{trackingResponse.parcel.parcelNumber}}
            </div>
            <div class="label" *ngIf="trackingResponse.parcel.parcelNumber === null || trackingResponse.parcel.parcelNumber ===''" dataqsi="numeroColis">
                {{trackingResponse.parcel.parcelNumberInput}}
            </div>
            <div class="labelExpedition" *ngIf="trackingResponse.parcel.customerCompanyName || trackingResponse.parcel.customerLogoURL"> {{ "header.expedition" | translate}} </div>
            <img class="headerCompanyLogo" *ngIf="trackingResponse.parcel.customerLogoURL != null" dataqsi="logoChargeur" src="{{trackingResponse.parcel.customerLogoURL}}">
            <div class="headerCompanyName" *ngIf="!trackingResponse.parcel.customerLogoURL || trackingResponse.parcel.customerLogoURL === null || trackingResponse.parcel.customerLogoURL === '' ">
                {{trackingResponse.parcel.customerCompanyName}}
            </div>
        </div>
    </div>
</div>
